
import style from '../../Style/Components/primary.module.scss';
import Loader from '../Loader/loader';

const PrimaryButton = (props) => {

    return (

        <button className={props.loading ? style.e_disabled : style.primary_button}
            type={props.type || 'submit'}
            data-bs-dismiss={props.cancel}
            onClick={props.handleClick}>
            {
                props.loading ?
                    <img src={require('../../Assets/Images/button-loader.gif')}
                          width={20}
                          height={20}  />
                    :
                    props.label
            }
        </button>
    );
}

export default PrimaryButton;